import React, { useEffect, useState } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr'
import OperatorAnnouncementModal from './Modal/OperatorAnnouncementModal'
import { useTranslation } from "react-i18next";

import './OperatorAnnouncement.css'

const OperatorAnnouncement = () => {
    const { t } = useTranslation();

    const [announcementList, setAnnouncementList] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [editingAnnouncement, setEditingAnnouncement] = useState(null);

    const getAuthHeaders = () => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) xsrfToken = xsrfToken.split('=')[1];

        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) token = token.split('=')[1];

        return {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
            'Bearer': decodeURIComponent(token),
            'Accept': 'application/json'
        };
    };

    const fetchAnnouncements = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/operator-announcements`, {
                method: 'GET',
                headers: getAuthHeaders(),
                credentials: 'include',
            });
            if (res.status === 200) {
                const data = await res.json();
                setAnnouncementList(data.operator_announcements || []);
            } else {
                console.error('Operator announcements fetch failed:', res.status);
                alert(t('operator_announcement.error_fetch'));
            }
        } catch (error) {
            console.error('Operator announcements fetch error:', error);
            alert(t('operator_announcement.error_fetch'));
        }
    };

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const handleAdd = () => {
        setEditingAnnouncement(null);
        setModalIsOpen(true);
    };

    const handleEdit = (announcement) => {
        setEditingAnnouncement(announcement);
        setModalIsOpen(true);
    };

    const handleDelete = async (announcement) => {
        if (!window.confirm(t('operator_announcement.confirm_delete'))) return;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/operator-announcements/${announcement.id}`, {
                method: 'DELETE',
                headers: getAuthHeaders(),
                credentials: 'include',
            });
            if (res.status === 200) {
                alert(t('operator_announcement.deleted'));
                fetchAnnouncements();
            } else {
                alert(t('operator_announcement.error_delete'));
            }
        } catch (error) {
            console.error('Operator announcement delete error:', error);
            alert(t('operator_announcement.error_delete'));
        }
    };

    const handleSave = async (payload, announcementId) => {
        try {
            const isEdit = !!announcementId;
            const url = isEdit
                ? `${process.env.REACT_APP_API_URL}/api/operator-announcements/${announcementId}`
                : `${process.env.REACT_APP_API_URL}/api/operator-announcements`;
            const method = isEdit ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                credentials: 'include',
                body: JSON.stringify(payload),
            });

            if (res.status === 200 || res.status === 201) {
                alert(isEdit ? t('operator_announcement.updated') : t('operator_announcement.created'));
                setModalIsOpen(false);
                setEditingAnnouncement(null);
                fetchAnnouncements();
            } else {
                const data = await res.json().catch(() => ({}));
                const errorMsg = data.message
                    || (data.errors ? Object.values(data.errors).flat().join('\n') : null)
                    || (isEdit ? t('operator_announcement.error_update') : t('operator_announcement.error_create'));
                alert(errorMsg);
            }
        } catch (error) {
            console.error('Operator announcement save error:', error);
            alert(announcementId ? t('operator_announcement.error_update') : t('operator_announcement.error_create'));
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setEditingAnnouncement(null);
    };

    return (
        <>
            <Header />
            <SideMenu />
            <div className="operator-announcement-list">
                <div className="operator-announcement-list-title">{t('operator_announcement.title')}</div>
                <button className="operator-announcement-list-add-button" onClick={handleAdd}>{t('operator_announcement.add')}</button>
                <div className='clearfix'></div>
                <div className="operator-announcement-list-note">{t('operator_announcement.cache_note')}</div>
                <div className="operator-announcement-list-content">
                    <table className="operator-announcement-list-content-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>{t('operator_announcement.text')}</th>
                                <th>{t('operator_announcement.display_period')}</th>
                                <th>{t('operator_announcement.status')}</th>
                                <th>{t('operator_announcement.sort_order')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {announcementList.length > 0 ? (
                                announcementList.map((announcement, index) => (
                                    <Tr key={announcement.id || index} announcement={announcement} onEdit={handleEdit} onDelete={handleDelete} />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="operator-announcement-list-empty">{t('operator_announcement.empty')}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <OperatorAnnouncementModal
                isOpen={modalIsOpen}
                onClose={closeModal}
                onSave={handleSave}
                announcement={editingAnnouncement}
            />
        </>
    )
}

export default OperatorAnnouncement
